import React from 'react';
import styles from './HeaderSection.module.css';
import backIcon from '../../assets/BACKBTN.svg'; // 뒤로가기 아이콘 이미지
import { useNavigate } from 'react-router-dom';

const HeaderSection = ({ title, onBack, onCancel }) => {
  const navigate = useNavigate();

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <div className={styles.headerContainer}>

      {/* 뒤로 가기 버튼 */}
      <div className={styles.headerLeft}>
        {onBack && (
          <button className={styles.backButton} onClick={onBack}>
            <img src={backIcon} alt="뒤로가기" className={styles.backIcon} />
          </button>
        )}
      </div>


      {/* <div className={styles.headerLeft}>
        <button className={styles.backButton} onClick={onBack}>
          <img src={backIcon} alt="뒤로가기" className={styles.backIcon} />
        </button>
      </div> */}


      {/* 헤더 타이틀 */}
      <div className={styles.headerTitle}>{title}</div>

      {/* 취소 버튼 */}
      <div className={styles.headerRight}>
        {onCancel && (
          <button className={styles.cancelButton} onClick={handleCancel}>
            취소
          </button>
        )}
      </div>
    </div>
  );
};

export default HeaderSection;
